import { render, staticRenderFns } from "./XMark.vue?vue&type=template&id=402ab532&"
import script from "./XMark.vue?vue&type=script&lang=js&"
export * from "./XMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports